var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stu-club"},[_c('div',{staticClass:"club-grid"},_vm._l((_vm.clubList),function(item,index){return _c('club-card',{key:index,attrs:{"club":item,"is-student":_vm.user_type == 'student',"default-club-image":_vm.defaultClubImage,"is-joined":true},nativeOn:{"click":function($event){return _vm.actionToClubDetail(item)}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }